import { gql } from '@apollo/client'

import { CommentFragment } from '../fragments'

export const MUTATION_CREATE_COMMENT = gql`
  mutation createComment($input: CommentCreateInput!) {
    createComment(input: $input) {
      ...CommentFragment
    }
  }
  ${CommentFragment}
`

export const MUTATION_DELETE_COMMENT = gql`
  mutation deleteComment($input: CommentDeleteInput!) {
    deleteComment(input: $input)
  }
`

export const MUTATION_CREATE_COMMENT_FOR_PROJECT_FILE_VALIDATION_REQUEST = gql`
  mutation createCommentForProjectFileValidationRequest($input: CommentCreateForProjectFileValidationRequestInput!) {
    createCommentForProjectFileValidationRequest(input: $input) {
      ...CommentFragment
    }
  }
  ${CommentFragment}
`
